/**
=========================================================
* Soft UI Dashboard PRO React - v3.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components

import Grid from "@mui/material/Grid";

import Card from "@mui/material/Card";

// Soft UI Dashboard PRO React components
import SuiBox from "components/SuiBox";

import SuiTypography from "components/SuiTypography";

// Soft UI Dashboard PRO React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

import DataTable from "examples/Tables/DataTable";
import DefaultProjectCard from "examples/Cards/ProjectCards/DefaultProjectCard";

// Overview page components

// Data

import dataTableDatamedical from "layouts/pages/Patient/pharmacyplace/data/dataTableDataMedical";

import pharmacy1 from "assets/images/pharmacy1.jfif";
import pharmacy2 from "assets/images/pharmacy2.jfif";
import pharmacy3 from "assets/images/pharmacy3.jfif";
import pharmacy4 from "assets/images/pharmacy4.jfif";

import medicine1 from "assets/images/medicine1.jfif";

function PharmacyPlace() {
  // DefaultStatisticsCard state for the dropdown value

  // DefaultStatisticsCard state for the dropdown action

  // DefaultStatisticsCard handler for the dropdown action

  // Dropdown menu template for the DefaultStatisticsCard

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SuiBox py={3}>
        <SuiBox mb={3}>
          <Card>
            <SuiBox pt={2} px={2}>
              <SuiBox mb={0.5}>
                <SuiTypography variant="h5" color="gradient" fontWeight="medium">
                  Search Pharmacies for Medicines
                </SuiTypography>
              </SuiBox>
            </SuiBox>
            <SuiBox p={2}>
              <Grid container spacing={3}>
                <Grid item xs={12} md={6} xl={3}>
                  <DefaultProjectCard
                    image={medicine1}
                    label="Esomephrazole"
                    title="Carry Medical "
                    logo={pharmacy1}
                    price="10 RM"
                    description="Carry Medical Provide Fresh and Excellent Quality Drugs"
                    action={{
                      type: "internal",
                      route: "/pages/profile/profile-overview",
                      color: "primary",
                      label: "Buy Now",
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={6} xl={3}>
                  <DefaultProjectCard
                    image={medicine1}
                    logo={pharmacy2}
                    label="Esomephrazole"
                    title="Pool Medical"
                    price="9 RM"
                    description="High Quality is Our Strenght we provide good"
                    action={{
                      type: "internal",
                      route: "/pages/profile/profile-overview",
                      color: "primary",
                      label: "Buy Now",
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={6} xl={3}>
                  <DefaultProjectCard
                    image={medicine1}
                    logo={pharmacy3}
                    label="Esomephrazole"
                    title="OK Phramacy"
                    price="8 RM"
                    description="Different people have different taste, and various types of tablet."
                    action={{
                      type: "internal",
                      route: "/pages/profile/profile-overview",
                      color: "primary",
                      label: "Buy Now",
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={6} xl={3}>
                  <DefaultProjectCard
                    image={medicine1}
                    logo={pharmacy4}
                    label="Esomephrazole"
                    title="Hamza Pharma"
                    price="11 RM"
                    description="Different people have different taste, and various types of music."
                    action={{
                      type: "internal",
                      route: "/pages/profile/profile-overview",
                      color: "primary",
                      label: "Buy Now",
                    }}
                  />
                </Grid>
              </Grid>
            </SuiBox>
          </Card>
        </SuiBox>

        <Grid container spacing={3}>
          <Grid item xs={12}>
            <SuiBox my={3}>
              <Card>
                <SuiBox
                  display="flex"
                  justifyContent="space-between"
                  alignItems="flex-start"
                  paddingTop={3}
                  paddingLeft={3}
                >
                  <SuiBox>
                    <SuiTypography variant="h5" fontWeight="medium">
                      6 Medicine returned for the keyword Esso
                    </SuiTypography>
                  </SuiBox>
                </SuiBox>
                <DataTable
                  table={dataTableDatamedical}
                  entriesPerPage={{
                    defaultValue: 7,
                    entries: [5, 7, 10, 15, 20, 25],
                  }}
                  canSearch
                />
              </Card>
            </SuiBox>
          </Grid>
        </Grid>
      </SuiBox>
      <Footer />
    </DashboardLayout>
  );
}

export default PharmacyPlace;
